import { Link } from 'react-router-dom';

export const ProfileSelect = ({ profiles, profileId, onChange, allowGeneral = false }) => (
  <div className="mb-6">
    <label className="block text-sm mb-2 font-medium" htmlFor="birth-profile">Birth profile</label>
    <select id="birth-profile" data-testid="birth-profile-select" className="w-full bg-white border border-[#E5DDD4] rounded-lg px-3 py-3" value={profileId} onChange={e => onChange(e.target.value)}>
      {allowGeneral && <option value="">General rashi guidance</option>}
      {!allowGeneral && !profiles.length && <option value="">No birth profiles</option>}
      {profiles.map(p => <option key={p.profile_id} value={p.profile_id}>{p.name}</option>)}
    </select>
    {!profiles.length && <Link to="/profiles" data-testid="create-birth-profile-link" className="inline-block text-sm text-[#C84B32] mt-2 underline">Add a birth profile</Link>}
  </div>
);